import { forwardRef } from 'react'
import DatePicker from 'react-datepicker'
import { ru } from 'date-fns/locale'

import 'react-datepicker/dist/react-datepicker.css'

interface DateFilterProps {
  value: Date | null
  onChange: (v: Date | null) => void
  label?: string
  placeholder?: string
  withTime?: boolean
}

const PickerInput = forwardRef<HTMLInputElement, any>((props, ref) => (
  <input
    {...props}
    ref={ref}
    className='form-control form-control-solid ps-12'
    autoComplete='off'
    type='text'
  />
))
PickerInput.displayName = 'DateFilterInput'

/**
 * Single-date filter for FilterManager.
 *
 * Mounts under the `'date'` key. Value: `Date | null`.
 *
 * @example
 * <FilterManager
 *   activeFilters={[{ filter: 'date', fieldName: 'startedAt' }]}
 *   filterProps={{ startedAt: { label: 'Дата начала', withTime: true } }}
 *   onApplyFilters={(f) => console.log(f.startedAt)}
 * />
 */
export function DateFilter({
  value,
  onChange,
  label,
  placeholder = 'Дата',
  withTime = false,
}: DateFilterProps) {
  return (
    <>
      {label && (
        <label className='fs-6 form-label fw-bolder text-dark d-block'>{label}</label>
      )}
      <div className='position-relative d-flex align-items-center'>
        <div className='symbol symbol-20px me-4 position-absolute ms-4 calendar-icon-datepicker'>
          <i className='fa fa-calendar-alt'></i>
        </div>
        <DatePicker
          selected={value}
          onChange={(d) => onChange(d as Date | null)}
          customInput={<PickerInput placeholder={placeholder} />}
          locale={ru}
          showTimeInput={withTime}
          dateFormat={withTime ? 'dd.MM.yyyy HH:mm' : 'dd.MM.yyyy'}
          shouldCloseOnSelect={!withTime}
        />
      </div>
    </>
  )
}
